import PreviazaneTerminyUpdate from './PreviazaneTerminyUpdate';

export default PreviazaneTerminyUpdate;
